/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-array-index-key */
import { useContext, useEffect, useState } from "react";
import {
  MdCancel,
  MdClose,
  MdCreateNewFolder,
  MdDashboard,
  MdReport,
} from "react-icons/md";
import { BiCheckShield, BiLockAlt, BiLogOut, BiUser } from "react-icons/bi";
import { FaCashRegister, FaRoute, FaTicketAlt } from "react-icons/fa";
import { Link, useNavigate, NavLink } from "react-router-dom";
import {
  Menubar,
  MenubarMenu,
  MenubarTrigger,
  MenubarContent,
  MenubarItem,
  Separator,
  Avatar,
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuContent,
} from "@repo/ui";
import { User2Icon } from "lucide-react";
import AuthContext from "store/auth-context";
import { useUser } from "hooks/use-user";
import { defaultFilters, FiltersContext } from "store/filters-context";
import Logo from "../assets/images/logo.png";
import { PATHS } from "../routes/paths";
import { isCallCenterAgent } from "pages/tickets/utils";

const COMMAND_CENTER_ADMIN = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
];
const CALL_CENTER_AGENT = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Calls",
    to: PATHS.allServiceAndNonServiceCalls,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Create Service Calls",
    to: PATHS.createTicket,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Facilities Request",
        to: PATHS.createFacilityTickets,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Remote Support Request",
        to: PATHS.createRemoteSupportRequest,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Customer Complaint",
        to: PATHS.createCustomerComplaint,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Customer Service",
        to: PATHS.createCustomerService,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Etisalat Third Party",
        to: PATHS.createEtisalatThirdParty,
      },
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Unusual Event",
        to: PATHS.createUnusualEvent,
      },
    ],
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Service Calls",
    to: PATHS.allTickets,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Open (Non Cash)",
        to: PATHS.openTickets,
      },
      {
        icon: <FaCashRegister className="text-nav" />,
        text: "Open (Cash)",
        to: PATHS.cashTickets,
      },

      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Assigned",
        to: PATHS.assignedTickets,
      },
      {
        icon: <BiCheckShield className="text-nav" />,
        text: "Vault Access",
        to: PATHS.vaultAccessTickets,
      },
      {
        icon: <BiUser className="text-nav" />,
        text: "Resolved",
        to: PATHS.resolvedTickets,
      },
      {
        icon: <BiUser className="text-nav" />,
        text: "Awaiting",
        to: PATHS.awaitingTickets,
      },

      {
        icon: <MdClose className="text-nav" />,
        text: "Closed",
        to: PATHS.closedTickets,
      },
      {
        icon: <MdCancel className="text-nav" />,
        text: "Cancelled",
        to: PATHS.cancelledTickets,
      },
    ],
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "CCA Calls",
    to: PATHS.allCalls,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Open",
        to: PATHS.openCalls,
      },

      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Assigned",
        to: PATHS.assignedCalls,
      },

      {
        icon: <BiUser className="text-nav" />,
        text: "Resolved",
        to: PATHS.resolvedCalls,
      },

      {
        icon: <MdClose className="text-nav" />,
        text: "Closed Calls",
        to: PATHS.closedCalls,
      },
      {
        icon: <MdCancel className="text-nav" />,
        text: "Cancelled",
        to: PATHS.cancelledCalls,
      },
    ],
  },
  //new service call(create new tickets with dropdown),

  //service calls(list)[non cash tickets,cash tickets,assigned,vault access resolved,awaiting,closed,cancelled],
  //CCA Calls(list)[open, assigned, in progress, resolved, closed, cancelled]
  //my calls(list)
  //bulk operations
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "My Tickets",
    to: PATHS.myCalls,
  },
  {
    icon: <MdCreateNewFolder className="text-nav" />,
    text: "Bulk",
    to: PATHS.bulkOperation,
  },
  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
  },
];

const CC_CALLS = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Calls",
    to: PATHS.allServiceAndNonServiceCalls,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "CCA Calls",
    to: PATHS.allCalls,
    subMenu: [
      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Open",
        to: PATHS.openCalls,
      },

      {
        icon: <FaTicketAlt className="text-nav" />,
        text: "Assigned",
        to: PATHS.assignedCalls,
      },

      {
        icon: <BiUser className="text-nav" />,
        text: "Resolved",
        to: PATHS.resolvedCalls,
      },

      {
        icon: <MdClose className="text-nav" />,
        text: "Closed",
        to: PATHS.closedCalls,
      },
      {
        icon: <MdCancel className="text-nav" />,
        text: "Cancelled",
        to: PATHS.cancelledCalls,
      },
    ],
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "My Tickets",
    to: PATHS.myCalls,
  },
  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
  },
];

const CALL_OUT_DISPATCHER = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Tickets",
    to: PATHS.allTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Open",
    to: PATHS.openTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Assigned",
    to: PATHS.assignedTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Gunnebo",
    to: PATHS.gunnebo,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Non Gunnebo",
    to: PATHS.nonGunnebo,
  },
  {
    icon: <BiUser className="text-nav" />,
    text: "My Tickets",
    to: PATHS.selfAssignedTickets,
  },
  {
    icon: <MdClose className="text-nav" />,
    text: "Closed",
    to: PATHS.closedTickets,
  },

  {
    icon: <FaRoute className="text-nav" />,
    text: "Routes",
    to: "/routes",
  },

  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
  },
];

const SLM_DISPATCHER = [
  {
    icon: <MdDashboard className="text-nav" />,
    text: "Dashboard",
    to: PATHS.dashboard,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "All Tickets",
    to: PATHS.allTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Open",
    to: PATHS.openTickets,
  },
  {
    icon: <FaTicketAlt className="text-nav" />,
    text: "Assigned",
    to: PATHS.assignedTickets,
  },
  {
    icon: <BiUser className="text-nav" />,
    text: "My Tickets",
    to: PATHS.selfAssignedTickets,
  },
  {
    icon: <MdClose className="text-nav" />,
    text: "Closed",
    to: PATHS.closedTickets,
  },
  {
    icon: <MdReport className="text-nav" />,
    text: "Reports",
    to: PATHS.reports,
  },
];
export default function Header() {
  const user = useUser();
  const isSLMEngineer = user.Roles.includes("SLM Engineer Dispatcher");
  const isCCCalls = user.Roles.includes("CC Calls");
  const isCommandCenterAdmin = user.Roles.includes("CC Dashboard");
  let _links;
  if (isCommandCenterAdmin) {
    _links = COMMAND_CENTER_ADMIN;
  } else if (isCCCalls) {
    _links = CC_CALLS;
  } else if (isCallCenterAgent(user)) {
    _links = CALL_CENTER_AGENT;
  } else if (isSLMEngineer) {
    _links = SLM_DISPATCHER;
  } else {
    _links = CALL_OUT_DISPATCHER;
  }

  const authCtx = useContext(AuthContext);

  const [navLinks, setNavLinks] = useState(_links);
  const [menuLinks, setMenuLinks] = useState(null);
  const { setFilters } = useContext(FiltersContext);
  const navigate = useNavigate();

  useEffect(() => {
    const eventHandler = () => {
      const _screenWidth = window.innerWidth;

      if (_screenWidth <= 1600) {
        setNavLinks([..._links.slice(0, 7)]);
        setMenuLinks(_links.length > 7 ? [..._links.slice(7)] : null);
      } else if (_screenWidth <= 1800) {
        setNavLinks([..._links.slice(0, 10)]);
        setMenuLinks(_links.length > 10 ? [..._links.slice(10)] : null);
      } else if (_screenWidth <= 2000) {
        setNavLinks([..._links.slice(0, 13)]);
        setMenuLinks(_links.length > 13 ? [..._links.slice(7)] : null);
      }
    };
    eventHandler();
    window.addEventListener("resize", eventHandler);
    return () => window.removeEventListener("resize", eventHandler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleLogout = () => {
    authCtx.logout();
  };
  const goToProfile = () => {
    navigate(PATHS.profile);
  };
  const goToChangePassword = () => {
    navigate(PATHS.changePassword);
  };

  return (
    <header className="bg-white shadow-lg fixed-header">
      <nav
        className=" flex  items-center  p-6 lg:px-6 lg:py-3.5 w-full"
        aria-label="Global"
      >
        <Link to="/">
          <img className="w-[65px]" src={Logo} alt="" />
        </Link>

        <Separator orientation="vertical" className="h-8 mx-8" />
        <div className="lg:flex gap-[25px] items-center">
          <NavigationMenu>
            <NavigationMenuList className="flex flex-row gap-2">
              {navLinks.map((elm, index) => {
                if (elm.subMenu) {
                  return (
                    <NavigationMenuItem key={index}>
                      <NavigationMenuTrigger style={{ height: "auto" }}>
                        {elm.to ? (
                          <NavLink
                            to={elm.to}
                            className="header-links"
                            onClick={() => {
                              setFilters({ ...defaultFilters });
                            }}
                          >
                            <div className="flex flex-col gap-[4px] justify-center items-center w-full">
                              <div className="p-[2px] rounded-lg text-white w-fit text-xs bg-nav">
                                {elm.icon}
                              </div>
                              <div className="flex flex-row justify-center items-center">
                                <p className="text-primary text-sm">
                                  {elm.text}
                                </p>
                              </div>
                            </div>
                          </NavLink>
                        ) : (
                          <div className="flex flex-col gap-[4px] justify-center items-center w-full">
                            <div className="p-[2px] rounded-lg text-white w-fit text-xs bg-nav">
                              {elm.icon}
                            </div>
                            <div className="flex flex-row justify-center items-center">
                              <p className="text-primary text-sm">{elm.text}</p>
                            </div>
                          </div>
                        )}
                      </NavigationMenuTrigger>
                      <NavigationMenuContent dir="ventricle">
                        <ul className="p-2 w-[250px]">
                          {elm.subMenu.map((subItem) => (
                            <li key={subItem.to}>
                              <Link
                                onClick={() => {
                                  setFilters({ ...defaultFilters });
                                }}
                                className="w-full block text-sm hover:bg-secondary/20 p-2 rounded-md text-nowrap"
                                to={subItem.to}
                              >
                                {subItem.text}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </NavigationMenuContent>
                    </NavigationMenuItem>
                  );
                }

                return (
                  <NavigationMenuItem key={index}>
                    <NavLink
                      to={elm.to}
                      className="header-links"
                      onClick={() => {
                        setFilters({ ...defaultFilters });
                      }}
                    >
                      <div className="flex flex-col gap-[4px] justify-center items-center w-full">
                        <div className="p-[2px] rounded-lg text-white w-fit text-xs bg-nav">
                          {elm.icon}
                        </div>
                        <div className="flex flex-row justify-center items-center">
                          <p className="text-primary text-sm">{elm.text}</p>
                        </div>
                      </div>
                    </NavLink>
                  </NavigationMenuItem>
                );
              })}
            </NavigationMenuList>
          </NavigationMenu>
          {menuLinks ? (
            <Menubar>
              <MenubarMenu>
                <MenubarTrigger>More</MenubarTrigger>

                <MenubarContent>
                  {menuLinks?.map((elm, index) => (
                    <MenubarItem key={`${index}${elm.text}`}>
                      <Link
                        to={elm.to}
                        onClick={() => {
                          setFilters({ ...defaultFilters });
                        }}
                      >
                        <div className="flex flex-row justify-center items-center">
                          <p className="text-primary text-sm">{elm.text}</p>
                        </div>
                      </Link>
                    </MenubarItem>
                  ))}
                </MenubarContent>
              </MenubarMenu>
            </Menubar>
          ) : (
            <></>
          )}
        </div>

        <div className="flex items-center gap-4 ml-auto">
          <span className="uppercase text-sm">{user.DisplayName}</span>
          <Menubar className="border-none">
            <MenubarMenu>
              <MenubarTrigger>
                <Avatar
                  style={{
                    backgroundColor: "#c6c6c6",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                  }}
                >
                  {/* <AvatarImage src="https://github.com/shadcn.png" /> */}
                  <User2Icon />
                  {/* <AvatarFallback>{user.DisplayName}</AvatarFallback> */}
                </Avatar>
              </MenubarTrigger>
              <MenubarContent>
                <MenubarItem className="gap-3" onClick={goToProfile}>
                  <BiUser />
                  Profile
                </MenubarItem>
                <MenubarItem className="gap-3" onClick={goToChangePassword}>
                  <BiLockAlt />
                  Change Password
                </MenubarItem>
                <MenubarItem className="gap-3" onClick={handleLogout}>
                  <BiLogOut />
                  Logout
                </MenubarItem>
              </MenubarContent>
            </MenubarMenu>
          </Menubar>
        </div>
      </nav>
    </header>
  );
}
